'use strict';

import ConfiguratorImageChanger from './../utils/configurator-image-changer';
import '../../css/configurator.scss';
import * as _ from 'lodash';
import PreviousChoiceSetter from './../utils/previous-choice-setter';
import ImageCleaner from "../utils/image-cleaner";

$(document).ready(function () {
    this.ajaxTimeOut = undefined;
    // function  isSafari() {
    //     return !!navigator.userAgent.match(/safari/i) && !navigator.userAgent.match(/chrome/i) && typeof document.body.style.webkitFilter !== "undefined" && !window.chrome ? true : false;
    // }
    // $('input[type="radio"]').on('click', function () {
    //     let thisRadio = $(this);
    //     console.log('click');
    //     setTimeout(function () {
    //         if (thisRadio.is(':checked') && isSafari()) {
    //             console.log('in if');
    //             thisRadio.prop('checked', false);
    //         }
    //     }, 100);
    // });


    (new ConfiguratorImageChanger()).setUpListeners();

    const configurationForm = $('form[name=configuration_form]');
    const $radioButtons = $('form[name=configuration_form] input[type=radio]');
    const $checkBoxButtons = $('form[name=configuration_form] input[type=checkbox]');
    $radioButtons
        // uncheck other radio buttons on input
        .on('input', (event) => {
            const $input = $(event.target);
            $input
                .data('isChecked', true)
                .siblings('label')
                .addClass('active');
            $input.closest('.wysiwig')
                .find('input[type=radio]')
                .not($input)
                .prop('checked', false)
                .removeData('isChecked')
                .trigger('change')
                .siblings('label')
                .removeClass('active');

            $input.parents('.card')
                .find('.select-button')
                .attr('disabled', false);

            timeInterval = handleFormSubmit(configurationForm, timeInterval);
        })
        // add class to radio inputs labels when initializing view
        .filter((_, input) => $(input).is(':checked'))
        .siblings('label')
        .addClass('active');

    $radioButtons.on('click', (event) => {
        const $radioButton = $(event.target);

        if ($radioButton.data('isChecked')) {
            $radioButton.prop('checked', false)
                .removeData('isChecked')
                .trigger('change')
                .siblings('label')
                .removeClass('active');
            configurationForm.trigger('input');

            if (!$radioButton.parents('.card').find('.select-button').hasClass('optional-select-button')) {
                $radioButton.parents('.card')
                    .find('.select-button')
                    .attr('disabled', 'disabled');
            }
            // must be in if
            // event on radioButton not trigger input on uncheck radio
            timeInterval = handleFormSubmit(configurationForm, timeInterval);
        }
    });

    $checkBoxButtons.on('click', (event) => {
        timeInterval = handleFormSubmit(configurationForm, timeInterval);
    });

    $('.configuration_page .elements .text-wrap').click(function () {
        let checkbox = $(this).closest('.elements').find('input[type="checkbox"]');
        let checkboxStatus = checkbox.prop('checked');
        checkbox.prop('checked', !checkboxStatus);
    });

    function toggleAdditionalConfiguration($input) {

        setDefaultValueForInput($input);

        if ($input.is(':checked')) {
            $input
                .closest('.elements')
                .find('.additional-configuration')
                .show();
        } else if (!$input.is(':checked')) {
            $input
                .closest('.elements')
                .find('.additional-configuration')
                .css('display', 'none');
            $input
                .closest('.elements')
                .find('.additional-configuration input')
                .val(null);
        }
    }

    function setDefaultValueForInput($input) {

        let additionalConfigurationText = $input
            .closest('.elements')
            .find('.additional-configuration')
            .find('input[type="text"]')
        ;
        if (additionalConfigurationText !== undefined) {
            let inputValue = $(additionalConfigurationText).val();

            if (canBePasedToInt(inputValue) && inputValue >= 1) {
                return;
            }

            $(additionalConfigurationText).val(1);
        }
    }

    function canBePasedToInt(value) {
        return !isNaN(parseInt(value));
    }

    function isString(inputValue) {
        return Object.prototype.toString.call(inputValue) === "[object String]"
    }

    $('.equipment-enabler input')
        // toggle configuration fields (quantity, additional dimension) when input changes
        .on('change', event => toggleAdditionalConfiguration($(event.target)))
        // initialize view with configuration fields hidden/shown depending on value
        .each((_, element) => toggleAdditionalConfiguration($(element)));


    function watchOnChosenBtns() {
        $(".accordion .card").each(function () {
            let headerOfCard = $(this).closest('.card').find('.card-header');
            let isChecked = false;
            $(this).find('.card-body .wysiwig .elements').each(function () {
                let checkBox = $(this).find('.form-check input');
                if (checkBox.prop('checked')) {
                    isChecked = true;
                }
            });
            if (isChecked) {
                if (!headerOfCard.hasClass('chosen')) {
                    headerOfCard.addClass('chosen');
                }
            } else {
                if (headerOfCard.hasClass('chosen')) {
                    headerOfCard.removeClass('chosen');
                }
            }
        });
    }

    // $('input[type="checkbox"][view="radio"]').change(function () {
    //     $(this).closest('.card-body').find('input[type="checkbox"][view="radio"]').prop('checked', false);
    //     $(this).prop('checked', true);
    // });

    watchOnChosenBtns();
    $('.configuration_page .wysiwig').click(function () {
        watchOnChosenBtns();
        $(this).closest('.card').removeClass('error');
    });

    function findErrorBlock() {
        let findError = $('.invalid-feedback');
        findError.closest('.card').addClass('error');
    }

    findErrorBlock();

    let heightOfOpis;
    $('.opis_produkta ul li').each(function () {
        heightOfOpis = $(this).find('.sub').height();
    });
    $('.opis_produkta .btni').click(function () {
        if (!$(this).closest('.wrap').find('.sub').length === false) {
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
                $(this).closest('.wrap').removeClass('show_sub')
            } else {
                $(this).addClass('open');
                $(this).closest('.wrap').addClass('show_sub')
            }
        }
    });

    $('.color_attr .elements').each(function () {
        let chooseColor = $(this).find('.wrap_for_circle').attr('data-color');
        $(this).find('label').css('--tooltip-color', chooseColor);
    });

    // quantity increment/decrement
    $('.quantity-stepper').on('click', event => {
        const $input = $(event.target).closest('.quantity-wrapper').find('input');
        const inputValue = +$input.val();
        const incrementValue = $(event.target).hasClass('quantity-stepper')
            ? $(event.target).data('increment')
            : $(event.target).closest('.quantity-stepper').data('increment');
        if (!Number.isInteger(inputValue) || !Number.isInteger(incrementValue)) {
            return;
        }
        const newValue = inputValue + incrementValue;
        $input
            .val(newValue < 1 ? 1 : newValue > 99 ? 99 : newValue)
            .trigger('input');
    });
    $('input[type="radio"]').closest('.checkbox_industi').addClass('radio_industi');
    $('.quantity-stepper').closest('.quantity-wrapper').addClass('hasButtons');
    $('select.form-control').closest('.d-flex').addClass('hasButtons');

    // configuration price
    let cancelRadioButtons = $('.cancel-radio-button');
    let cancelCheckboxButtons = $('.cancel-checkbox-button');
    let selectButtons = $('.select-button');
    let checkboxArray = $('.equipment-enabler ');
    let quantitySteppers = $('.quantity-stepper ');
    let timeInterval = handleFormSubmit(configurationForm, null);

    checkboxArray.on('change', (event) => {
        const $input = $(event.target);

        let cardHeader = $input.parents('.card').find('.card-header');

        if (!$input.parents('.card').find('.select-button').hasClass('optional-select-button')) {
            if (cardHeader.hasClass('chosen')) {
                $input.parents('.card')
                    .find('.select-button')
                    .attr('disabled', false);
            } else {
                $input.parents('.card')
                    .find('.select-button')
                    .attr('disabled', 'disabled');
            }
        }

        let additionalEquipmentForm = $input.parents('.row .elements').find('.additional-configuration').find('.form-group');

        // if (!additionalEquipmentForm.length) {
        //     timeInterval = handleFormSubmit(configurationForm,timeInterval);
        // }
    });

    quantitySteppers.on('click', () => {
        timeInterval = handleFormSubmit(configurationForm, timeInterval);
    });

    $("select").on('change', () => {
        timeInterval = handleFormSubmit(configurationForm, timeInterval);
    });

    cancelRadioButtons.on('click', (event) => {
        const $input = $(event.target);


        $input.parents('.card')
            .find('.collapse')
            .collapse('hide');
    });

    cancelCheckboxButtons.on('click', (event) => {
        const $input = $(event.target);

        $input.parents('.card')
            .find('.collapse')
            .collapse('hide');
    });

    selectButtons.on('click', (event) => {
        const $input = $(event.target);

        $input.parents('.card')
            .find('.collapse')
            .collapse('hide');

        $input.parents('.card')
            .next()
            .find('.collapse')
            .addClass('show');
    });

    function handleFormSubmit(configurationForm, timeInterval) {
        if (!$('#target1').prev().hasClass('chosen')) {
            return null;
        }

        if (timeInterval !== null) {
            window.clearTimeout(timeInterval);
        }

        if (configurationForm.attr('price-action') === undefined) {
            return null;
        }

        return setTimeout(function () {
                $.ajax({
                    url: configurationForm.attr('price-action'),
                    method: 'POST',
                    data: configurationForm.serialize(),
                })
                    .done(data => {
                        $('#configuration-price').text(_.get(data, 'price', 0));
                        $('.configuration-price').empty();

                        $.each($('.standard-version-price'), function (k, val) {
                            let parent = $(val).parent();
                            if (!$(parent).hasClass('d-none')) {
                                $(parent).addClass('d-none');
                            }
                        })

                        $.each(_.get(data, 'configurationPrice', []), function (key, value) {
                            $('#configuration-price-' + key).text(value);
                            $('#configuration-price-' + key).parent().removeClass('d-none');
                        });
                    });
            }, 1500
        );
    }

    let searchingElemWrap = $('.faq_accordion .card-body .equipment-enabler');
    searchingElemWrap.find('input[type="radio"]').closest('.equipment-enabler').addClass('radio_industi');
    searchingElemWrap.find('input[type="checkbox"]').closest('.equipment-enabler').addClass('checkbox_industi');

    //BackToPrevChoise

    const previousChoiceSetter = new PreviousChoiceSetter();

    $('.card-body .elements').each(function () {
        let img = $(this).find('.wrap_for_circle img.bg');
        $(this).closest('.elements').find('label').prepend(img);
    });

    const imageCleaner = new ImageCleaner()

    if (/MSIE \d|Trident.*rv:/.test(navigator.userAgent)) {
        $('.ie-warning').css("display", 'block');
    }

});



// WEBPACK FOOTER //
// ./assets/js/configurator/configurator-index.js